import React, { useEffect, useState } from 'react';
import Button from '../../../../button/button';
import './EnrollGroup.scss';
import Select from '../../../../select/select';
import Modal from '../../../../modal/modal';
import { PostInscriptionStudentToGroup } from '../../../../../utils/Apis/apis';
import Autocomplete from '../../../../../DesignSystem/Molecules/Autocomplete/Autocomplete';
import GroupAutocompleteOption from '../../../Groups/GroupAutocompleteOption/GroupAutocompleteOption';

const EnrollGroupModal = ({ isOpen, onClose, classes, subsidiaryList, studentId, showAlert, refreshData, student_st }) => {
    const [filteredBySubsidiary, setFilteredBySubsidiary] = useState([]);
    const [classesList, setClassesList] = useState([])
    const [subsidiarySelected, setSubsidiarySelected] = useState('')
    const [classSelected, setClassSelected] = useState(null)
    const [typeClassSelected, setTypeClassSelected] = useState('')

    const typeClassOptions = [{
        value: 1,
        label: 'Clase de ingles'
    },
    {
        value: 2,
        label: 'Club de escritura y lectura'
    },
    {
        value: 3,
        label: 'Club de conversación'
    }
    ]
    const handleSubsidiarySelected = (value) => {
        setSubsidiarySelected(value);
        setTypeClassSelected('');
        setClassSelected(null);
        
        const classesFilter = classes.filter(c => c.detail_class.subsidiary.id === parseInt(value) && c.detail_class.is_finished === 0 && c.detail_class.st === 0);
        setFilteredBySubsidiary(classesFilter);
        setClassesList(classesFilter); // al inicio, sin tipo de clase aún
    };

    const handleTypeClassSelected = (value) => {
        setTypeClassSelected(value);
        const classesFilter = filteredBySubsidiary.filter(
            c => c.detail_class.type_class?.id === parseInt(value)
        );
        setClassesList(classesFilter);
        setClassSelected(null)
    };
    // Función para construir el nombre completo
    const getFullName = (classes) => {
        return classes.label
    };

    const handleChangeGroup = (v) => {
        setClassSelected(v)
    }


    const handleConfirmInscription = async () => {
        const registerToGroup = await PostInscriptionStudentToGroup(classSelected.value, studentId)
        if (registerToGroup.status === 200) {
            showAlert('success', registerToGroup.message)
            if (student_st === 0) {
                setTimeout(() => {
                    window.location.reload()
                }, 2000);
            } else {
                refreshData()
                onClose()
            }
        } else {
            showAlert('danger', registerToGroup.message)
        }
    }
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <div className="enroll-group main-color">
                <h1 className='title-1'>Inscribir a grupo</h1>
                <section className="enroll-group-body">
                    <Select
                        value={subsidiarySelected}
                        options={subsidiaryList}
                        placeholder="Selecciona una Sucursal"
                        classN='main-color'
                        onChange={(e) => handleSubsidiarySelected(e.target.value)}
                    />
                    <Select
                        value={typeClassSelected}
                        options={typeClassOptions}
                        placeholder="Selecciona un tipo de clase"
                        classN='main-color'
                        onChange={(e) => handleTypeClassSelected(e.target.value)}
                        disabled={!subsidiarySelected && true}
                    />
                    <Autocomplete
                        options={classesList}
                        renderOption={(option) => <GroupAutocompleteOption id={option.id} group={option.detail_class} />}
                        dropdownClassName="group-autocomplete-dropdown"
                        maxVisibleOptions={8}
                        getOptionLabel={(option) => getFullName(option)} // Controla cómo se muestra el texto en las opciones
                        value={
                            classSelected
                        } // Aquí pasas el objeto completo
                        isOptionEqualToValue={(option, value) => option.value === value.value} // Comparación basada en el 'id'
                        placeholder={"Buscar Grupo..."}
                        onChange={handleChangeGroup}
                        disabled={!typeClassSelected || !subsidiarySelected || classesList.length === 0 && true}

                    />
                </section>
                <section className='confirm-buttons-section'>
                    <Button backgroundColor="red" text="Cerrar" onClick={onClose} />
                    <Button backgroundColor="blue" text="Confirmar" disabled={!classSelected} onClick={handleConfirmInscription} />
                </section>
            </div>
        </Modal>
    );
};

export default EnrollGroupModal;
